export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6379.9d2a8580.jpg";